import { FrameName } from "../config";
import GrasslandTerrainTileEntity from "./GrasslandTerrainTileEntity";

class Grassland2TerrainTileEntity extends GrasslandTerrainTileEntity {
	public static readonly frameName = FrameName.GRASSLAND2;
}

export default Grassland2TerrainTileEntity;
